module.exports = __webpack_public_path__ + "media/assets/stores/barnes-and-noble-de30be843ec71865ced193346f789372.jpg";